import moduleAccountAdmin from './account-admin';
import moduleDocumentManagement from './document-management';

export default {
  namespaced: true,
  modules: {
    accountAdmin: moduleAccountAdmin,
    documentManagement: moduleDocumentManagement,
  },
};
